<div ng-controller="registerNodeGeneralController as regNodeCtrl" class="risk-details" ng-class="{'modal-view': regNodeCtrl.isModal()}">
    <c-auto-form config="regNodeCtrl.autoFormConfig"></c-auto-form>
</div>